import {
  Box,
  Button,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import view from "../../Assets/View.png";
import edit from "../../Assets/edit.png";
import { useNavigate } from "react-router-dom";
import PathList from "../../Common/PathList";
import { API_GET, API_GET2, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import SearchFiedComponent from "../../Component/SearchComponent";
import debounce from "lodash.debounce";
import moment from "moment";
import AddNewCouponModal from "./AddNewCouponModal";
import { render } from "@testing-library/react";
import { useFormik } from "formik";
import { toast } from "react-toastify";

const PAGE_SIZE_OPTIONS = [15];

function DiscountCouponManagement() {
  const [data, setData] = useState();
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalData, setModalData] = useState({});
  const [open, setOpen] = useState(false);

  const [subScriptionType, setSubScriptionType] = useState([]);

  const getSubscriptionType = async () => {
    try {
      const res = await API_GET2(API_endspoints.getSubscriptionType);
      if (res?.s) {
        const updatedData = res?.r
          ?.filter((item) => item.is_trial === 0)
          .map((item) => ({
            label: `${item?.name} (${
              item?.month === 1 ? "Monthly" : "Annually"
            })`,
            value: item?.id,
          }));
        const all = { id: -1, label: "All", value: -1 };
        setSubScriptionType([all, ...updatedData]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSubscriptionType();
  }, []);

  //  const formik = useFormik({
  //    status: modalData?.status || 1,
  //  })

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 50,
      headerAlign: "center",
      renderCell: (params) => params.row.rowid + page * rowsPerPage,
    },

    {
      headerClassName: "super-app-theme--header",
      field: "coupon_code",
      headerName: "Code",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "coupon_name",
      headerName: "Coupon Name",
      flex: 1,
      minWidth: 180,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 180,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "subscription_type",
      headerName: "Subscription Type",
      flex: 1,
      minWidth: 180,
      headerAlign: "center",
      renderCell: (cell) =>
        subScriptionType?.find(
          (item) => item.value === cell?.row?.subscription_type
        )?.label,
    },

    {
      headerClassName: "super-app-theme--header",
      field: "discount_amount",
      headerName: "Discount",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.discount_type === 1
          ? `${cell?.row?.discount_amount}%`
          : `€${cell?.row?.discount_amount}`,
    },
    {
      headerClassName: "super-app-theme--header",
      field: "start_date",
      headerName: "Validity",
      width: 200,
      headerAlign: "center",
      renderCell: (params) => {
        const startDate = params.row.start_date
          ? moment(params.row.start_date).local().format("ll")
          : "-";
        const endDate = params.row.end_date
          ? moment(params.row.end_date).local().format("ll")
          : "-";

        return `${startDate} - ${endDate}`;
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "usage_limit",
      headerName: "Usage Limit",
      width: 200,
      headerAlign: "center",
      renderCell: (params) => {
        const startDate = params.row.used_usage_count;

        const endDate = params.row.total_usage_limit;

        return `${startDate} / ${endDate}`;
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "usage_limit_per_user",
      headerName: "Usage Limit Per User",
      width: 160,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "status",
      headerName: "Status",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (cell) => {
        const isActive = cell?.row?.status === 1;
        return (
          <Switch
            disabled={IsLoading}
            checked={isActive}
            onChange={() => handleCouponStatusChange(cell?.row)}
            id={`status-switch-${cell?.row?.id}`}
            name={`status-${cell?.row?.id}`}
            color="warning"
            inputProps={{
              "aria-label": `Toggle status for ${cell?.row?.name || "item"}`,
            }}
          />
        );
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "is_Active",
      headerName: "Action",
      width: 120,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              onClick={() => {
                setOpen(true);
                setModalData(cell?.row);
              }}
              className="ImgHover"
              src={edit}
              alt="icon"
              height={24}
              width={24}
            />
          </Box>
          {/* <MenuOption /> */}
        </Box>
      ),
    },
  ];

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const getData = async (
    selectedStatus,
    prevStatus,
    search = "",
    previousSearch = "",
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0]
  ) => {
    try {
      setIsLoading(true);
      // let newPage = page;
      // if (search !== previousSearch || prevStatus !== selectedStatus)
      // {
      //   newPage = 0;
      //   setPage(0);
      // }
      // let queryParams = new URLSearchParams({
      //   count: newPage * pageSize,
      //   offset: pageSize,
      // });
      // if (search.length > 0) {
      //   queryParams.append("search", search);
      // }
      // if (selectedStatus) {
      //   queryParams.append("role", selectedStatus);
      // }
      // const api = `${API_endspoints.getalluser}?${queryParams.toString()}`;
      const api = `${API_endspoints.getDiscountCouponList}?is_admin=1`;
      let res = await API_GET(api);
      const Rowdata = res?.r?.map((data, i) => ({
        rowid: i + 1,
        ...data,
      }));
      if (res?.r?.length > 0) {
        setData(Rowdata);
        setTotalData(res?.c ?? 0);
      } else {
        setData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    const status = event.target.value;
    setSelectedStatus(status);
  };
  const handleCouponStatusChange = async (data) => {
    const status = data?.status === 1 ? -1 : 1;
    const id = data?.id;
    const formdata = new FormData();
    formdata.append("id", id);
    formdata.append("status", status);
    try {
      setIsLoading(true);
      const api = API_endspoints.UpdateDiscountCoupon;
      let res = await API_POST(api, formdata);
      if (res?.s) {
        toast.success(`Coupon updated successfully`);
        await getData();
      } else {
        toast.warn(res?.m);
        setModalData({});
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const statusRef = useRef(selectedStatus);
  const searchRef = useRef(searchTerm);
  const debouncedFetchData = debounce(() => {
    getData(
      selectedStatus,
      statusRef.current,
      searchTerm,
      searchRef.current,
      page,
      rowsPerPage
    );
    searchRef.current = searchTerm;
    statusRef.current = selectedStatus;
  }, 400);

  useEffect(() => {
    debouncedFetchData();
    return () => {
      debouncedFetchData.cancel();
    };
  }, [page, rowsPerPage, searchTerm, selectedStatus]);

  return (
    <Box sx={{ height: "calc(100vh - 55px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
          px: 2,
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          Discount Coupon Management
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1, // Adds spacing between label and dropdown
          }}
        >
          {/* <SearchFiedComponent
            onChange={handleSearch}
            placeholder={"Search"}
            value={searchTerm}
          />
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            displayEmpty
            size="small"
            sx={{
              minWidth: 150,
              padding: "4px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "1px solid #CED7E4",
              backgroundColor: "#F9F9F9",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select> */}
          <AddNewCouponModal
            open={open}
            modalData={modalData}
            setModalData={setModalData}
            setOpen={setOpen}
            getData={() =>
              getData(
                selectedStatus,
                statusRef.current,
                searchTerm,
                searchRef.current,
                page,
                rowsPerPage
              )
            }
          />
        </Box>
      </Box>
      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 60px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={false}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
    </Box>
  );
}

export default DiscountCouponManagement;
